
/**
 * [shop description]
 * @return {[type]} [description]
 */
var shop = function(){

	/**
	 * [shopApp description]
	 * @type {[type]}
	 */
	var shopApp = this;

	/**
	 * [categories description]
	 * @return {[type]} [description]
	 */
	this.categories = function(){

		/**
		 * [removeHandler description]
		 * @param  {[type]} e [description]
		 * @return {[type]}   [description]
		 */
		var removeHandler = function(e)
		{
			e.preventDefault();
			$.get( this.href, function( model ){
				$('[data-category-id="' + model.id + '"]').fadeOut( 200, function(){
					$(this).remove();
					var tbody = $('[data-for="category-category-list"]');
					if( ! $('tr', tbody ).length ) {
						var row = $('<tr />').attr('data-for','no-categories');
						$('<td />').attr('colspan', 4).text('No categories currently attached to this product').appendTo(row);
						row.appendTo(tbody);
					}
				});
			});
		};

		/**
		 * [addCategoryToList description]
		 * @param {[type]} elm [description]
		 */
		var addCategoryToList = function( elm )
		{
			var model = elm.data( 'category' );
			var tbody = $('[data-for="category-category-list"]');

			$('[data-for="no-categories"]', tbody).remove();

			var row = $('<tr />').attr( 'data-category-id', model.id );
			$('<td />').text( model.id ).appendTo( row );
			$('<td />').text( model.name ).appendTo( row );
			$('<td />').text( 'n/a' ).appendTo( row );

			var buttonCol = $('<td />');
			var buttons = $('<div class="ui small icon basic buttons" />');
					var deleteButton = $('<a data-for="remove-category-category" class="ui button"><i class="align trash red icon"></i></a>')
						.attr('data-row-id', model.id)
						.attr('href', model.delete_url);

			deleteButton.appendTo(buttons);
			buttons.appendTo(buttonCol);
			buttonCol.appendTo(row);

			row.appendTo(tbody);

			$('#search-results', $('body')).remove();
			$('#category_category_search').val('');
			bindEvents();

			$.ajax({
				url : model.attach_url,
				type : 'POST',
				headers : {
                	'X-CSRF-TOKEN' : $('[name="_token"]').val()
                }
			})

		};

		var xhr;

		/**
		 * [categorySearchHandler description]
		 * @param  {[type]} e [description]
		 * @return {[type]}   [description]
		 */
		var categorySearchHandler = function(e)
		{
			var route = $.fn.ensphere.veto.singleSelect('#category-search-categories-route').value;
			var value = this.value;

			if( value.length <= 1 ) {
				$('#search-results', $('body')).remove();
				return;
			}

			if( xhr && xhr.readystate != 4 ) xhr.abort();
			$.get( route + '?query=' + value, function( categories ){

				var searchContainer = $('<div />').addClass('c-ajax-filter__results').attr( 'id', 'search-results' );
				var list = $( '<ul />' ).appendTo( searchContainer );

				if( ! categories.length ) {
					var item = $( '<li />' ).addClass('c-ajax-filter__results__item').text( 'No results found or the category is already attached.' );
					item.appendTo( list );
				}

				categories.forEach(function(category){
					var item = $( '<li />' ).addClass( 'c-ajax-filter__results__item' ).attr( 'data-category-id', category.id );
					item.data( 'category', category );
					item.text( category.name );
					item.appendTo( list );
					item.click( function(){
						addCategoryToList( $(this) );
					});
					item.mouseenter(function(){
						$(this).addClass('c-ajax-filter__results__item--hover');
					})
					.mouseleave(function(){
						$(this).removeClass('c-ajax-filter__results__item--hover');
					});
				});
				$('#search-results', $('body')).remove();
				searchContainer.appendTo($('body'));
				var searchBox = $('#category_category_search');
				var searchBoxOffset = searchBox.offset();
				searchContainer.css({
					'top'  : ( searchBoxOffset.top + searchBox.outerHeight() ) + 'px',
					'left' : ( searchBoxOffset.left ) + 'px',
					'width' : ( searchBox.outerWidth() ) + 'px'
				});
			});

		};

		/**
		 * [removeSearchContainer description]
		 * @param  {[type]} e [description]
		 * @return {[type]}   [description]
		 */
		var removeSearchContainer = function(e)
		{
			if( ! $(e.target).parents('#search-results:eq(0)').length ) {
				$('#search-results', $('body')).remove();
			}
		};

        /**
		 *
         */
        var initOrdering = function()
        {
            var token = $('[name="_token"]').val();
            $('.orderable').each( function(){
                var url = $(this).attr( 'data-url' );
                $(this).rowSorter({
                    onDrop: function( tbody, row, new_index, old_index ) {
                        var table = $(tbody.tagName.toLowerCase() === "tbody" ? tbody.parentNode : tbody);
                        var ids = [];
                        $('tbody tr', table).each(function(){
                            ids.push( $(this).attr('data-row-id') );
                        });
                        $.ajaxSetup({
                            headers: { 'X-CSRF-TOKEN': token }
                        });
                        $.post( url, { orders : ids }, function( response ){
                            console.log(response);
                        });
                    }
                });
            });
        };

		/**
		 * [bindEvents description]
		 * @return {[type]} [description]
		 */
		var bindEvents = function()
		{
            $.fn.ensphere.veto.select('[data-for="edit-category-site"]').forEach( function( elm ){
				elm.addEventListener( "click", editHandeler );
			});
            $.fn.ensphere.veto.select('[data-for="remove-category-category"]').forEach(function(elm){
                $.fn.ensphere.veto.clickEvent( elm, removeHandler );
			});

			$.fn.ensphere.veto.keyUpEvent( $.fn.ensphere.veto.singleSelect('#category_category_search'), categorySearchHandler );
            $.fn.ensphere.veto.clickEvent( document, removeSearchContainer );
			$.fn.ensphere.veto.focusEvent( $.fn.ensphere.veto.singleSelect('#category_category_search'), categorySearchHandler );
            initOrdering();
		};

		/**
		 * [editHandeler description]
		 * @param  {[type]} e [description]
		 * @return {[type]}   [description]
		 */
		var editHandeler = function(e)
		{
			e.preventDefault();
			$.fn.ensphere.veto.modalEdit( this, {
				onVisible : function( modalObj ){
					$('.redactor', modalObj).redactor({
						minHeight : 300,
						toolbarFixed : false
					});
					setTimeout( function(){
						modalObj.semanticUiModal('refresh');
					}, 500);
				},
				onComplete : function( response, attributes, modal ){
					updateCategorySiteRow( response, attributes, modal );
				}
			});
		};

		/**
		 * [updateCategorySiteRow description]
		 * @param  {[type]} model      [description]
		 * @param  {[type]} attributes [description]
		 * @param  {[type]} modal      [description]
		 * @return {[type]}            [description]
		 */
		var updateCategorySiteRow = function( model, attributes, modal )
		{
			modal.semanticUiModal('hide');
			var row = $('[data-category-site-id="' + model.id + '"]');
			$('[data-for="category-site-name"]', row).text( model.name );
			$('[data-for="category-site-slug"]', row).text( model.slug );
		};

		/**
		 * [description]
		 * @return {[type]} [description]
		 */
		return new function()
		{

			/**
			 * [init description]
			 * @return {[type]} [description]
			 */
			this.init = function()
			{
				bindEvents();
			}
		}

	};

	/**
	 * [inventories description]
	 * @return {[type]} [description]
	 */
	this.inventories = function(){

		/**
		 * [_inventories description]
		 * @return {[type]} [description]
		 */
		var _inventories = function(){

			/**
			 * [app description]
			 * @type {[type]}
			 */
			var app = this;

			/**
			 * [bindMiscModalEvents description]
			 * @param  {[type]} modalObj [description]
			 * @return {[type]}          [description]
			 */
			var bindMiscModalEvents = function( modalObj )
			{
				$('select', modalObj).not('[data-for="default-teacher"] select').dropdown({
				    on: 'click'
				});
				$('[data-for="remove-teacher"]', modalObj).unbind('click').click(function(e){
					e.preventDefault();
					$(this).parents('.item.form-group:eq(0)').remove();
				});
				$('[data-for="adding-another-teacher"]', modalObj).unbind('click').click(function(e){
					e.preventDefault();
					var defaultTeacherField = $('[data-for="default-teacher"]', modalObj).clone();
					var removeButton = $('<div class="form-group"><a data-for="remove-teacher" class="btn btn-danger" href="#">Remove</a></div>');
					defaultTeacherField.removeAttr('data-for');
					$('option', defaultTeacherField).prop('selected', false);
					$('option:eq(0)', defaultTeacherField).prop('selected', true);
					removeButton.appendTo($('.form-group:eq(1)', defaultTeacherField));
					removeButton.click(function(e){
						e.preventDefault();
						$(this).parents('.item.form-group:eq(0)').remove();
					});
					defaultTeacherField.insertAfter($('[data-for="default-teacher"]', modalObj));

				});
			};

			/**
			 * [repopulateVoucherInventoryRow description]
			 * @param  {[type]} model [description]
			 * @param  {[type]} row   [description]
			 * @return {[type]}       [description]
			 */
			var repopulateVoucherInventoryRow = function( model, row )
			{
				$('[data-for="stock"]', row).text( model.stock );
				$('[data-for="sku"]', row).text( model.sku );
				$('[data-for="price"]', row).text( model.voucher_data.type_id == '2' ? 'n/a' : model.price );
				$('[data-for="min-price"]', row).text( model.voucher_data.type_id == '1' ? 'n/a' : model.voucher_data.min_price );
				$('[data-for="max-price"]', row).text( model.voucher_data.type_id == '1' ? 'n/a' : model.voucher_data.max_price );
				$('[data-for="type"]', row).text( model.voucher_data.display_type );
				$('[data-for="status"]', row).html( model.status );
			};

			/**
			 * [updateInventoryRow description]
			 * @param  {[type]} model          [description]
			 * @param  {[type]} inventoryRowId [description]
			 * @return {[type]}                [description]
			 */
			this.updateInventoryRow = function( model, inventoryRowId )
			{
				var row = $('[data-row-id="' + inventoryRowId + '"]');
				if( row.length ) {
					if( model.voucher_data ) {
						repopulateVoucherInventoryRow( model, row );
					} else {
						$('[data-for="stock"]', row).text( model.stock );
						$('[data-for="sku"]', row).text( model.sku );
						$('[data-for="barcode"]', row).text( model.barcode );
						$('[data-for="price"]', row).text( model.price );
						$('[data-for="recommended_retail_price"]', row).text( model.recommended_retail_price );
						if( model.status ) {
							$('[data-for="status"]', row).html( model.status );
						}
					}
				} else {
					var row = $('<tr />');
					row.attr('data-row-id', model.id);
					$('<td />').attr('data-for', 'id').text(model.id).appendTo(row);
					$('<td />').attr('data-for', 'date').text(model.date).appendTo(row);
					$('<td />').attr('data-for', 'stock').text(model.stock).appendTo(row);
					$('<td />').attr('data-for', 'venue').text(model.venue_name).appendTo(row);
					$('<td />').attr('data-for', 'sku').text(model.sku).appendTo(row);
					$('<td />').attr('data-for', 'price').text(Number(model.price).toFixed(5)).appendTo(row);
					$('<td />').attr('data-for', 'status').html(model.status).appendTo(row);
					var buttonCol = $('<td />');
					var buttons = $('<div class="ui small icon basic buttons" />');
					var editButton = $('<a data-for="edit-inventory" class="ui button"><i class="align edit green icon"></i></a>')
						.attr('data-for-row-id', model.id)
						.attr('href', model.edit_url);
					var deleteButton = $('<a data-for="delete-inventory" class="ui button"><i class="align trash red icon"></i></a>')
						.attr('data-for-row-id', model.id)
						.attr('href', model.delete_url);
					editButton.appendTo(buttons);
					deleteButton.appendTo(buttons);
					buttons.appendTo(buttonCol);
					buttonCol.appendTo(row);
					row.appendTo($('[data-tab="inventory"] tbody'));
					app.bindEvents();
				}
			};

			/**
			 * [updateAllInventoryRows description]
			 * @param  {[type]} model [description]
			 * @return {[type]}       [description]
			 */
			this.updateAllInventoryRows = function( models )
			{
				for( var i in models ) {
					app.updateInventoryRow( models[i], models[i].id );
				}
			};

			/**
			 * [editHandeler description]
			 * @return {[type]} [description]
			 */
			this.editHandeler = function(e){
				e.preventDefault();
                $.fn.ensphere.veto.modalEdit( this, {
					onVisible : function( modalObj ){
						bindMiscModalEvents( modalObj );
					},
					onComplete : function( response, attributes, modal ){
						modal.semanticUiModal('hide');
						app.updateInventoryRow( response, attributes['data-for-row-id'] );
					}
				});
			};

			/**
			 * [bulkUpdateHandeler description]
			 * @return {[type]} [description]
			 */
			this.bulkUpdateHandeler = function(e){
				e.preventDefault();
                $.fn.ensphere.veto.modalEdit( this, {
					onComplete : function( response, attributes, modal ){
						modal.semanticUiModal('hide');
						app.updateAllInventoryRows( response );
					}
				});
			};

			/**
			 * [createHandeler description]
			 * @param  {[type]} e [description]
			 * @return {[type]}   [description]
			 */
			this.createHandeler = function(e){
				e.preventDefault();
                $.fn.ensphere.veto.modalEdit( this, {
					onVisible : function( modalObj ){
						bindMiscModalEvents( modalObj );
					},
					onComplete : function( response, attributes, modal ){
						modal.semanticUiModal('hide');
						app.updateInventoryRow( response );
					}
				});
			};

			/**
			 * [notesHandeler description]
			 * @param  {[type]} e [description]
			 * @return {[type]}   [description]
			 */
			this.notesHandeler = function(e){
				e.preventDefault();
                $.fn.ensphere.veto.modalEdit( this, {
					onComplete : function( response, attributes, modal ) {
						if( typeof response.note !== 'undefined' && response.deleted ) {
							$('[data-note-row="' + response.id + '"]').fadeOut(200, function(){
								$(this).remove();
								var notesBody = $('[data-for="notes-list"]', modal);
								if( ! $('tr', notesBody).length ) {
									var emptyRow = $('<tr />').attr('data-for', 'no-notes');
									$('<td />').attr('colspan', 4).text('You have not yet created any notes').appendTo(emptyRow);
									emptyRow.appendTo(notesBody);
								}
							});
						} else {
							modal.semanticUiModal('hide');
						}
					},
					onVisible : function( modalObj ){
						bindMiscModalEvents( modalObj );
					}
				});
			};

			/**
			 * [deleteHandeler description]
			 * @param  {[type]} e [description]
			 * @return {[type]}   [description]
			 */
			this.deleteHandeler = function(e){
				e.preventDefault();
				var button = this;
				swal({
			        title: "Are you sure?",
			        text: "This action cannot be reversed",
			        type: "warning",
			        showCancelButton: true,
			        confirmButtonClass: 'btn-danger',
			        confirmButtonText: 'Yes, delete it!',
			        cancelButtonText: "No, cancel please!",
			        closeOnConfirm: false,
			        closeOnCancel: false
		        }, function( isConfirm ) {
			        if ( isConfirm ) {
                        $.fn.ensphere.veto.modalEdit( button, {
							onResponse : function( response, attributes ){
								swal.close();
								$('tr[data-row-id="' + attributes['data-for-row-id'] + '"]').fadeOut(200, function(){
									$(this).remove();
								});
							}
						});
			        } else {
			            swal.close();
			        }
			    });
			};

			/**
			 * [bindEvents description]
			 * @return {[type]} [description]
			 */
			this.bindEvents = function()
			{
				$.fn.ensphere.veto.select('[data-for="edit-inventory"]').forEach( function( elm ){
                    $.fn.ensphere.veto.clickEvent( elm, app.editHandeler );
				});
                $.fn.ensphere.veto.select('[data-for="bulk-inventory"]').forEach(function(elm){
                    $.fn.ensphere.veto.clickEvent( elm, app.bulkUpdateHandeler );
				});
                $.fn.ensphere.veto.select('[data-for="create-booking-inventory"]').forEach(function(elm){
                    $.fn.ensphere.veto.clickEvent( elm, app.createHandeler );
				});
                $.fn.ensphere.veto.select('[data-for="delete-inventory"]').forEach(function(elm){
                    $.fn.ensphere.veto.clickEvent( elm, app.deleteHandeler );
				});
                $.fn.ensphere.veto.select('[data-for="notes"]').forEach(function(elm){
                    $.fn.ensphere.veto.clickEvent( elm, app.notesHandeler );
				});
			};

			/**
			 * [init description]
			 * @return {[type]} [description]
			 */
			this.init = function()
			{
				app.bindEvents();
			};

		};

		return new _inventories();

	};

	/**
	 * [products description]
	 * @return {[type]} [description]
	 */
	this.products = function(){

		/**
		 * [editResponse description]
		 * @param  {[type]} model            [description]
		 * @param  {[type]} buttonAttributes [description]
		 * @param  {[type]} modal            [description]
		 * @return {[type]}                  [description]
		 */
		var editResponse = function( model, buttonAttributes, modal )
		{
			modal.semanticUiModal('hide');
			var row = $('[data-product-site-id="' + model.id + '"]');
			$('[data-for="product-site-name"]', row).text( model.name );
			$('[data-for="product-site-slug"]', row).text( model.slug );
		};

		/**
		 * [editHandler description]
		 * @param  {[type]} e [description]
		 * @return {[type]}   [description]
		 */
		var editHandler = function(e){
			e.preventDefault();
            $.fn.ensphere.veto.modalEdit( this, {
				onVisible : function( modalObj ){
					$('.redactor', modalObj).redactor({
						minHeight : 300,
						toolbarFixed : false
					});
					setTimeout( function(){
						modalObj.semanticUiModal('refresh');
					}, 500);
				},
				onComplete : editResponse
			});
		};

		/**
		 * [removeHandler description]
		 * @param  {[type]} e [description]
		 * @return {[type]}   [description]
		 */
		var removeHandler = function(e)
		{
			e.preventDefault();
			e.stopPropagation();
			$.get( this.href, function( model ){
				$('[data-category-id="' + model.id + '"]').fadeOut( 200, function(){
					$(this).remove();
					var tbody = $('[data-for="product-category-list"]');
					if( ! $('tr', tbody ).length ) {
						var row = $('<tr />').attr('data-for','no-categories');
						$('<td />').attr('colspan', 4).text('No categories currently attached to this product').appendTo(row);
						row.appendTo(tbody);
					}
                    $.get( '/admin/shop/products/' + model.product_id + '/get-main-category-view', function( response ) {
                        var mainCategoryContainer = $( '[data-for="main-category"]' );
                        mainCategoryContainer.html('');
                        mainCategoryContainer.append( $( response ) );
                    });
				});
			});
			return false;
		};

		/**
		 * [removeRelatedHandler description]
		 * @param  {[type]} e [description]
		 * @return {[type]}   [description]
		 */
		var removeRelatedHandler = function(e)
		{
			e.preventDefault();
			e.stopPropagation();
			$.get( this.href, function( model ){
				$('[data-related-id="' + model.id + '"]').fadeOut( 200, function(){
					$(this).remove();
					var tbody = $('[data-for="product-related-list"]');
					if( ! $('tr', tbody ).length ) {
						var row = $('<tr />').attr('data-for','no-relations');
						$('<td />').attr('colspan', 4).text('No related products currently attached to this product').appendTo(row);
						row.appendTo(tbody);
					}
				});
			});
			return false;
		};

		/**
		 * [removeAccessoryHandler description]
		 * @param  {[type]} e [description]
		 * @return {[type]}   [description]
		 */
		var removeAccessoryHandler = function(e)
		{
			e.preventDefault();
			e.stopPropagation();
			$.get( this.href, function( model ){
				$('[data-accessory-id="' + model.id + '"]').fadeOut( 200, function(){
					$(this).remove();
					var tbody = $('[data-for="product-accessory-list"]');
					if( ! $('tr', tbody ).length ) {
						var row = $('<tr />').attr('data-for','no-accessories');
						$('<td />').attr('colspan', 4).text('No product accessories currently attached to this product.').appendTo(row);
						row.appendTo(tbody);
					}
				});
			});
			return false;
		};

		/**
		 * [removeArticleHandler description]
		 * @param  {[type]} e [description]
		 * @return {[type]}   [description]
		 */
		var removeArticleHandler = function(e)
		{
			e.preventDefault();
			e.stopPropagation();
			$.get( this.href, function( model ){
				$('[data-article-id="' + model.id + '"]').fadeOut( 200, function(){
					$(this).remove();
					var tbody = $('[data-for="product-articles-list"]');
					if( ! $('tr', tbody ).length ) {
						var row = $('<tr />').attr('data-for','no-articles');
						$('<td />').attr('colspan', 4).text('No articles currently attached to this product.').appendTo(row);
						row.appendTo(tbody);
					}
				});
			});
			return false;
		};

		/**
		 * [addCategoryToList description]
		 * @param {[type]} elm [description]
		 */
		var addCategoryToList = function( elm )
		{
			var model = elm.data( 'category' );
			var tbody = $('[data-for="product-category-list"]');

			$('[data-for="no-categories"]', tbody).remove();

			var row = $('<tr />').attr( 'data-category-id', model.id );
			$('<td />').text( model.id ).appendTo( row );
			$('<td />').text( model.name ).appendTo( row );
			$('<td />').text( 'n/a' ).appendTo( row );

			var buttonCol = $('<td />');
			var buttons = $('<div class="ui small icon basic buttons" />');
					var deleteButton = $('<a data-for="remove-category" class="btn btn-default btn-sm"><i class="fa fa-trash-o"></i></a>')
						.attr('data-row-id', model.id)
						.attr('href', model.delete_url);

			deleteButton.appendTo(buttons);
			buttons.appendTo(buttonCol);
			buttonCol.appendTo(row);

			row.appendTo(tbody);

			$('#search-results', $('body')).remove();
			$('#category_search').val('');
			bindEvents();

			$.ajax({
				url : model.attach_url,
				type : 'POST',
				headers : {
                	'X-CSRF-TOKEN' : $('[name="_token"]').val()
                },
                success : function( response ) {
                    $.get( '/admin/shop/products/' + response.product_id + '/get-main-category-view', function( response ) {
                        var mainCategoryContainer = $( '[data-for="main-category"]' );
                        mainCategoryContainer.html('');
                        mainCategoryContainer.append( $( response ) );
                    });
				}
			})

		};

		/**
		 * [addAccessoryToList description]
		 * @param {[type]} elm [description]
		 */
		var addAccessoryToList = function( elm )
		{
			var model = elm.data( 'product' );
			var tbody = $('[data-for="product-accessory-list"]');

			$('[data-for="no-accessories"]', tbody).remove();

			var row = $('<tr />').attr( 'data-related-id', model.id );
			$('<td />').text( model.id ).appendTo( row );
			$('<td />').text( model.name ).appendTo( row );
			$('<td />').text( 'n/a' ).appendTo( row );

			var buttonCol = $('<td />');
			var buttons = $('<div class="ui small icon basic buttons" />');
					var deleteButton = $('<a data-for="remove-related" class="ui button"><i class="align trash red icon"></i></a>')
						.attr('data-row-id', model.id)
						.attr('href', model.delete_url);

			deleteButton.appendTo(buttons);
			buttons.appendTo(buttonCol);
			buttonCol.appendTo(row);

			row.appendTo(tbody);

			$('#search-results', $('body')).remove();
			$('#accessories-search').val('');
			bindEvents();

			$.ajax({
				url : model.attach_url,
				type : 'POST',
				headers : {
                	'X-CSRF-TOKEN' : $('[name="_token"]').val()
                }
			})

		};

		/**
		 * [addRelatedToList description]
		 * @param {[type]} elm [description]
		 */
		var addRelatedToList = function( elm )
		{
			var model = elm.data( 'product' );
			var tbody = $('[data-for="product-related-list"]');

			$('[data-for="no-relations"]', tbody).remove();

			var row = $('<tr />').attr( 'data-related-id', model.id );
			$('<td />').text( model.id ).appendTo( row );
			$('<td />').text( model.name ).appendTo( row );
			$('<td />').text( 'n/a' ).appendTo( row );

			var buttonCol = $('<td />');
			var buttons = $('<div class="ui small icon basic buttons" />');
					var deleteButton = $('<a data-for="remove-related" class="ui button"><i class="align trash red icon"></i></a>')
						.attr('data-row-id', model.id)
						.attr('href', model.delete_url);

			deleteButton.appendTo(buttons);
			buttons.appendTo(buttonCol);
			buttonCol.appendTo(row);

			row.appendTo(tbody);

			$('#search-results', $('body')).remove();
			$('#related-search').val('');
			bindEvents();

			$.ajax({
				url : model.attach_url,
				type : 'POST',
				headers : {
                	'X-CSRF-TOKEN' : $('[name="_token"]').val()
                }
			})

		};

		/**
		 * [addArticleToList description]
		 * @param {[type]} elm [description]
		 */
		var addArticleToList = function( elm )
		{
			var model = elm.data( 'product' );
			var tbody = $('[data-for="product-articles-list"]');

			$('[data-for="no-articles"]', tbody).remove();

			var row = $('<tr />').attr( 'data-related-id', model.id );
			$('<td />').text( model.id ).appendTo( row );
			$('<td />').text( model.title ).appendTo( row );
			$('<td />').text( 'n/a' ).appendTo( row );

			var buttonCol = $('<td />');
			var buttons = $('<div class="ui small icon basic buttons" />');
					var deleteButton = $('<a data-for="remove-article" class="ui button"><i class="align trash red icon"></i></a>')
						.attr('data-row-id', model.id)
						.attr('href', model.delete_url);

			deleteButton.appendTo(buttons);
			buttons.appendTo(buttonCol);
			buttonCol.appendTo(row);

			row.appendTo(tbody);

			$('#search-results', $('body')).remove();
			$('#article-search').val('');
			bindEvents();

			$.ajax({
				url : model.attach_url,
				type : 'POST',
				headers : {
                	'X-CSRF-TOKEN' : $('[name="_token"]').val()
                }
			})

		};

		var xhr;

		/**
		 * [articleSearchHandler description]
		 * @param  {[type]} e [description]
		 * @return {[type]}   [description]
		 */
		var articleSearchHandler = function(e)
		{
			var route = $.fn.ensphere.veto.singleSelect('#article-search-route').value;
			var value = this.value;


			if( value.length <= 1 ) {
				$('#search-results', $('body')).remove();
				return;
			}

			if( xhr && xhr.readystate != 4 ) xhr.abort();
			$.get( route + '?query=' + value, function( products ){

				var searchContainer = $('<div />').addClass('c-ajax-filter__results').attr( 'id', 'search-results' );
				var list = $( '<ul />' ).appendTo( searchContainer );

				if( ! products.length ) {
					var item = $( '<li />' ).addClass('c-ajax-filter__results__item').text( 'No articles currently attached to this product.' );
					item.appendTo( list );
				}

				products.forEach(function(product){
					var item = $( '<li />' ).addClass( 'c-ajax-filter__results__item' ).attr( 'data-product-id', product.id );
					item.data( 'product', product );
					item.text( product.title );
					item.appendTo( list );
					item.click( function(){
						addArticleToList( $(this) );
					});
					item.mouseenter(function(){
						$(this).addClass('c-ajax-filter__results__item--hover');
					})
					.mouseleave(function(){
						$(this).removeClass('c-ajax-filter__results__item--hover');
					});
				});
				$('#search-results', $('body')).remove();
				searchContainer.appendTo($('body'));
				var searchBox = $('#article-search');
				var searchBoxOffset = searchBox.offset();
				searchContainer.css({
					'top'  : ( searchBoxOffset.top + searchBox.outerHeight() ) + 'px',
					'left' : ( searchBoxOffset.left ) + 'px',
					'width' : ( searchBox.outerWidth() ) + 'px'
				});
			});
		};

		/**
		 * [accessorySearchHandler description]
		 * @param  {[type]} e [description]
		 * @return {[type]}   [description]
		 */
		var accessorySearchHandler = function(e)
		{
			var route = $.fn.ensphere.veto.singleSelect('#accessories-search-route').value;
			var value = this.value;

			if( value.length <= 1 ) {
				$('#search-results', $('body')).remove();
				return;
			}

			if( xhr && xhr.readystate != 4 ) xhr.abort();
			$.get( route + '?query=' + value, function( products ){

				var searchContainer = $('<div />').addClass('c-ajax-filter__results').attr( 'id', 'search-results' );
				var list = $( '<ul />' ).appendTo( searchContainer );

				if( ! products.length ) {
					var item = $( '<li />' ).addClass('c-ajax-filter__results__item').text( 'No products found or the product is already attached.' );
					item.appendTo( list );
				}

				products.forEach(function(product){
					var item = $( '<li />' ).addClass( 'c-ajax-filter__results__item' ).attr( 'data-product-id', product.id );
					item.data( 'product', product );
					item.text( product.name );
					item.appendTo( list );
					item.click( function(){
						addAccessoryToList( $(this) );
					});
					item.mouseenter(function(){
						$(this).addClass('c-ajax-filter__results__item--hover');
					})
					.mouseleave(function(){
						$(this).removeClass('c-ajax-filter__results__item--hover');
					});
				});
				$('#search-results', $('body')).remove();
				searchContainer.appendTo($('body'));
				var searchBox = $('#accessories-search');
				var searchBoxOffset = searchBox.offset();
				searchContainer.css({
					'top'  : ( searchBoxOffset.top + searchBox.outerHeight() ) + 'px',
					'left' : ( searchBoxOffset.left ) + 'px',
					'width' : ( searchBox.outerWidth() ) + 'px'
				});
			});
		}

		/**
		 * [relatedSearchHandler description]
		 * @param  {[type]} e [description]
		 * @return {[type]}   [description]
		 */
		var relatedSearchHandler = function(e)
		{
			var route = $.fn.ensphere.veto.singleSelect('#related-search-route').value;
			var value = this.value;

			if( value.length <= 1 ) {
				$('#search-results', $('body')).remove();
				return;
			}

			if( xhr && xhr.readystate != 4 ) xhr.abort();
			$.get( route + '?query=' + value, function( products ){

				var searchContainer = $('<div />').addClass('c-ajax-filter__results').attr( 'id', 'search-results' );
				var list = $( '<ul />' ).appendTo( searchContainer );

				if( ! products.length ) {
					var item = $( '<li />' ).addClass('c-ajax-filter__results__item').text( 'No products found or the product is already attached.' );
					item.appendTo( list );
				}

				products.forEach(function(product){
					var item = $( '<li />' ).addClass( 'c-ajax-filter__results__item' ).attr( 'data-product-id', product.id );
					item.data( 'product', product );
					item.text( product.name );
					item.appendTo( list );
					item.click( function(){
						addRelatedToList( $(this) );
					});
					item.mouseenter(function(){
						$(this).addClass('c-ajax-filter__results__item--hover');
					})
					.mouseleave(function(){
						$(this).removeClass('c-ajax-filter__results__item--hover');
					});
				});
				$('#search-results', $('body')).remove();
				searchContainer.appendTo($('body'));
				var searchBox = $('#related-search');
				var searchBoxOffset = searchBox.offset();
				searchContainer.css({
					'top'  : ( searchBoxOffset.top + searchBox.outerHeight() ) + 'px',
					'left' : ( searchBoxOffset.left ) + 'px',
					'width' : ( searchBox.outerWidth() ) + 'px'
				});
			});
		}

		/**
		 * [categorySearchHandler description]
		 * @param  {[type]} e [description]
		 * @return {[type]}   [description]
		 */
		var categorySearchHandler = function(e)
		{
			var route = $.fn.ensphere.veto.singleSelect('#search-categories-route').value;
			var value = this.value;

			if( value.length <= 1 ) {
				$('#search-results', $('body')).remove();
				return;
			}

			if( xhr && xhr.readystate != 4 ) xhr.abort();
			$.get( route + '?query=' + value, function( categories ){

				var searchContainer = $('<div />').attr( 'id', 'search-results' ).addClass( 'c-ajax-filter__results' );
				var list = $( '<ul />' ).appendTo( searchContainer );

				if( ! categories.length ) {
					var item = $( '<li />' ).addClass( 'c-ajax-filter__results__item' ).text( 'No results found or the category is already attached.' );
					item.appendTo( list );
				}

				categories.forEach(function(category){
					var item = $( '<li />' ).addClass( 'c-ajax-filter__results__item' ).attr( 'data-category-id', category.id );
					item.data( 'category', category );
					item.text( category.name );
					item.appendTo( list );
					item.click( function(){
						addCategoryToList( $(this) );
					});
					item.mouseenter(function(){
						$(this).addClass('c-ajax-filter__results__item--hover');
					})
					.mouseleave(function(){
						$(this).removeClass('c-ajax-filter__results__item--hover');
					});
				});
				$('#search-results', $('body')).remove();
				searchContainer.appendTo($('body'));
				var searchBox = $('#category_search');
				var searchBoxOffset = searchBox.offset();
				searchContainer.css({
					'top'  : ( searchBoxOffset.top + searchBox.outerHeight() ) + 'px',
					'left' : ( searchBoxOffset.left ) + 'px',
					'width' : ( searchBox.outerWidth() ) + 'px'
				});
			});

		};

		/**
		 * [removeSearchContainer description]
		 * @param  {[type]} e [description]
		 * @return {[type]}   [description]
		 */
		var removeSearchContainer = function(e)
		{
			if( ! $(e.target).parents('#search-results:eq(0)').length ) {
				$('#search-results', $('body')).remove();
			}
		};

        /**
         * Product Image Re-order
         */
        var productImageReorder = function()
        {
            var images = $('.c-product-images:eq(0)');
            if( images.length ) {
                var sortable = Sortable.create( images.get(0), {
                    handle: '.c-product-images__image__handle'
                });
            }
        };


        var productImagePlaceholderTemplate = '' +
			'<div class="c-product-images__image">' +
            	'<input data-for="media-attachment" data-media-type="images" name="product_images[]" type="text">' +
            	'<div class="c-product-images__image__handle"><i class="fa fa-arrows"></i></div>' +
            '</div>';

        /**
		 * Remove Product Image
         * @param e
         */
		var removeProductImage = function(e)
		{
			e.preventDefault();
			$(this).parents( '.c-product-images__image:eq(0)' ).remove();
			if( ! $('.c-product-images__image').length ) {
                addNewProductImagePlaceholder();
			}
		};

        /**
		 * Add New Product Image Placeholder
         */
		var addNewProductImagePlaceholder = function()
		{
            var tmpl = $( productImagePlaceholderTemplate );
            tmpl.appendTo( $( '.c-product-images' ) );
            $( '[data-for="media-attachment"]', tmpl ).mediaManager();
        };

		/**
		 * [bindEvents description]
		 * @return {[type]} [description]
		 */
		var bindEvents = function(){
            $.fn.ensphere.veto.select('[data-for="edit-product-site"]').forEach(function(elm){
                $.fn.ensphere.veto.clickEvent( elm, editHandler );
			});
            $.fn.ensphere.veto.select('[data-for="remove-category"]').forEach(function(elm){
                $.fn.ensphere.veto.clickEvent( elm, removeHandler );
			});
			$.fn.ensphere.veto.keyUpEvent( $.fn.ensphere.veto.singleSelect('#category_search'), categorySearchHandler );
            $.fn.ensphere.veto.clickEvent( document, removeSearchContainer );
			$.fn.ensphere.veto.focusEvent( $.fn.ensphere.veto.singleSelect('#category_search'), categorySearchHandler );
			$.fn.ensphere.veto.keyUpEvent( $.fn.ensphere.veto.singleSelect('#related-search'), relatedSearchHandler );
			$.fn.ensphere.veto.focusEvent( $.fn.ensphere.veto.singleSelect('#related-search'), relatedSearchHandler );
            $.fn.ensphere.veto.select('[data-for="remove-related"]').forEach(function(elm){
				$(elm).unbind( 'click' );
                $.fn.ensphere.veto.clickEvent( elm, removeRelatedHandler );
			});
			$.fn.ensphere.veto.keyUpEvent( $.fn.ensphere.veto.singleSelect('#accessories-search'), accessorySearchHandler );
			$.fn.ensphere.veto.focusEvent( $.fn.ensphere.veto.singleSelect('#accessories-search'), accessorySearchHandler );
            $.fn.ensphere.veto.select('[data-for="remove-accessory"]').forEach(function(elm){
				$(elm).unbind( 'click' );
                $.fn.ensphere.veto.clickEvent( elm, removeAccessoryHandler );
			});

			$.fn.ensphere.veto.keyUpEvent( $.fn.ensphere.veto.singleSelect('#article-search'), articleSearchHandler );
			$.fn.ensphere.veto.focusEvent( $.fn.ensphere.veto.singleSelect('#article-search'), articleSearchHandler );
            $.fn.ensphere.veto.select('[data-for="remove-article"]').forEach(function(elm){
				$(elm).unbind( 'click' );
                $.fn.ensphere.veto.clickEvent( elm, removeArticleHandler );
			});

            $(document).on( 'click', '.c-product-images__image .btn-danger', removeProductImage );
            $(document).on( 'click', '[data-for="add-image-placeholder"]', addNewProductImagePlaceholder );

		};

		/**
		 * [description]
		 * @return {[type]} [description]
		 */
		return new function(){

			/**
			 * [init description]
			 * @return {[type]} [description]
			 */
			this.init = function(){
				bindEvents();
				productImageReorder();
			};
		};
	};

	/**
	 * [create description]
	 * @return {[type]} [description]
	 */
	this.create = function()
	{

		/**
		 * [onAddInventoryClickEvent description]
		 * @param  {[type]} e [description]
		 * @return {[type]}   [description]
		 */
		var onAddInventoryClickEvent = function(e)
		{
			e.preventDefault();
			var productID = $( 'select', $(this).parents('.ui.segment:eq(0)')).val();
			var displayStatus = $('select[name="display_status"]').val();
			$.get( '/admin/shop/orders/get-inventory/' + productID, { display_status : displayStatus }, function( response ){
				var attributes = getAttributes(this);
				$.fn.ensphere.veto.modalResponse( response, attributes, {
					onComplete : function( model, attributes, modal ){
						modal.semanticUiModal('hide');
						$('[data-for="no-items"]').remove();
						var row = $('<tr />')
							.attr('data-inventory-id', model.inventory_id)
							.attr('data-quantity', model.quantity)
							.attr('data-price', model.display_price);
						$('<td />').text( model.product_name ).appendTo( row );
						$('<td />').text( model.options ).appendTo( row );
						$('<td />').text( model.display_price ).appendTo( row );
						$('<td />').text( model.quantity ).appendTo( row );
						$('<td />').append('<div class="ui small icon basic buttons"><a class="ui button" href="javascript:window.removeInventoryRow(\'' + model.inventory_id + '\');"><i class="align trash red icon"></i></a></div>').appendTo( row );
						$('[data-for="inventory-items"]').append(row);


						var currentTotal = parseFloat( $('[data-for="sub-total"]').attr('data-value') );
						currentTotal += parseFloat( model.display_price );
						$('[data-for="sub-total"]').attr('data-value', currentTotal.toFixed(2) ).text( currentTotal.toFixed(2) );

					},
					onError : function( model, attributes, modal ){},
					onSave : function( model, attributes, modal ){},
					onResponse : function( model, attributes, modal ){},
					onVisible : function( model, attributes, modal ){},
					closeModal : true
				});
			});
		};

		var xhr;

		/**
		 * [populateCustomerData description]
		 * @param  {[type]} elm [description]
		 * @return {[type]}     [description]
		 */
		var populateCustomerData = function( elm )
		{
			var model = elm.data( 'customer' );
			var mirrorDelivery = $('[name="mirror_delivery"]');
			var fields = ['forename', 'surname', 'address_line_1', 'address_line_2', 'town', 'city', 'county', 'postcode', 'country_id'];
			fields.forEach( function( field ){
				$('[name="billing_' + field + '"]').val( model[field] );
				if( mirrorDelivery.is(':checked') ) {
					$('[name="shipping_' + field + '"]').val( model[field] );
				}
			});
			$('[name="customer_id"]').val(model.id);
			$('#search-results', $('body')).remove();
			$('[name="customer"]').val('');
		};

		/**
		 * [onCustomerKeyUpEvent description]
		 * @param  {[type]} e [description]
		 * @return {[type]}   [description]
		 */
		var onCustomerKeyUpEvent = function(e)
		{
			if( xhr && xhr.readystate != 4 ) xhr.abort();
			xhr = $.get( '/admin/shop/orders/search-customer', { query : $(this).val() }, function( customers ){
				var searchContainer = $('<div />').attr( 'id', 'search-results' ).addClass('c-ajax-filter__results');
				var list = $( '<ul />' ).appendTo( searchContainer );

				if( ! customers.length ) {
					var item = $( '<li />' ).addClass('c-ajax-filter__results__item').text( 'No customers found.' );
					item.appendTo( list );
				}

				customers.forEach(function(customer){
					var item = $( '<li />' ).addClass( 'c-ajax-filter__results__item' ).attr( 'data-customer-id', customer.id );
					item.data( 'customer', customer );
					item.text( customer.forename + ' ' + customer.surname );
					item.appendTo( list );
					item.click( function(){
						populateCustomerData( $(this) );
					});
					item.mouseenter(function(){
						$(this).addClass('c-ajax-filter__results__item--hover');
					})
					.mouseleave(function(){
						$(this).removeClass('c-ajax-filter__results__item--hover');
					});
				});
				$('#search-results', $('body')).remove();
				searchContainer.appendTo($('body'));
				var searchBox = $('[name="customer"]');
				var searchBoxOffset = searchBox.offset();
				searchContainer.css({
					'top'  : ( searchBoxOffset.top + searchBox.outerHeight() ) + 'px',
					'left' : ( searchBoxOffset.left ) + 'px',
					'width' : ( searchBox.outerWidth() ) + 'px'
				});
			});
		};

		/**
		 * [onCreateOrderEvent description]
		 * @return {[type]} [description]
		 */
		var onCreateOrderEvent = function(e)
		{
			if( $('[data-for="no-items"]').length ) {
				e.preventDefault();
				alert('Please add some items to the order');
			}
			$('tr[data-inventory-id]').each(function(i){
				$('<input />').attr('type','hidden').attr('name','inventory_id[]').val( $(this).attr('data-inventory-id') ).appendTo($('.create-order form'));
				$('<input />').attr('type','hidden').attr('name','quantity[]').val( $(this).attr('data-quantity') ).appendTo($('.create-order form'));
			});
		};

		/**
		 * [bindEvents description]
		 * @return {[type]} [description]
		 */
		var bindEvents = function()
		{
			$('[name="customer"]').bind( 'click keyup', onCustomerKeyUpEvent );
			$('[data-for="adding-inventory"]').click( onAddInventoryClickEvent );
			$('[data-for="creating-order"]').click( onCreateOrderEvent );
			window.removeInventoryRow = function(inventoryId)
			{
				$('tr[data-inventory-id="' + inventoryId + '"]').each(function(){
					var row = $(this);
					var currentTotal = parseFloat( $('[data-for="sub-total"]').attr('data-value') );
					var valueToRemove = parseFloat( row.attr('data-price') );
					currentTotal -= valueToRemove;
					$('[data-for="sub-total"]').attr('data-value', currentTotal.toFixed(2) ).text( currentTotal.toFixed(2) );
					row.fadeOut( 200, function(){
						$(this).remove();
						if( ! $('[data-for="inventory-items"] tr').length ) {
							$('[data-for="inventory-items"]').append('<tr data-for="no-items"><td class="error" colspan="5">No items yet added</td></tr>');
						}
					});
				});
			};
		};

		/**
		 * [init description]
		 * @return {[type]} [description]
		 */
		this.init = function()
		{

			/**
			 * [description]
			 * @return {[type]} [description]
			 */
			return new function()
			{
				bindEvents();
			};
		};
	};

	/**
	 * [viewOrder description]
	 * @return {[type]} [description]
	 */
	this.viewOrder = function()
	{

		/**
		 * [onAddItemClickEvent description]
		 * @param  {[type]} e [description]
		 * @return {[type]}   [description]
		 */
		var onAddItemClickEvent = function(e)
		{
			e.preventDefault();
            $.fn.ensphere.veto.modalEdit( this, {
				onComplete : function( model, attributes, modal ) {
					$('[data-for="item_subtotal_payable"]').html(model.item_subtotal_payable);
					$('[data-for="vat_payable"]').html(model.vat_payable);
					$('[data-for="shipping_payable"]').html(model.shipping_payable);
					$('[data-for="discount_deductable"]').html(model.discount_deductable);
					$('[data-for="total_payable"]').html(model.total_payable);
					var itemRow = $('<tr />')
						.append( $('<td />').html( model.item.product ) )
						.append( $('<td />').html( model.item.price ) )
						.append( $('<td />').html( model.item.quantity ) )
						.append( $('<td />').html( model.item.sub_total ) )

					itemRow.appendTo($('[data-for="items"]'));

					modal.semanticUiModal('hide');
				}
			});

		};

		/**
		 * [onAddNoteClickEvent description]
		 * @param  {[type]} e [description]
		 * @return {[type]}   [description]
		 */
		var onAddNoteClickEvent = function(e)
		{
			e.preventDefault();
            $.fn.ensphere.veto.modalEdit( this, {
				onComplete : function( model, attributes, modal ) {
					var tbody = $('tbody[data-for="notes"]');
					$('<tr />')
						.append( $('<td />').text( model.create_at_date ) )
						.append( $('<td />').text( model.author_name ) )
						.append( $('<td />').text( model.content ) )
					.appendTo( tbody );
					modal.semanticUiModal('hide');
				}
			});
		};

		/**
		 * [addToPayments description]
		 * @param {[type]} model [description]
		 */
		var addToPayments = function( model )
		{
			var tbody = $('[data-for="transactions"]');
			var tr = $('<tr />')
				.addClass('success')
				.append($('<td />').html(model.transaction.display_date) )
				.append($('<td />').html(model.transaction.display_amount) )
				.append($('<td />') )
				.append($('<td />').html(model.transaction.status) )
				.append($('<td />').html(model.transaction.status_detail) );
			tr.appendTo(tbody);
		};

		/**
		 * [updateRemaining description]
		 * @param  {[type]} model      [description]
		 * @param  {[type]} attributes [description]
		 * @return {[type]}            [description]
		 */
		var updateRemaining = function( model, attributes )
		{
			var button = $('[data-item-id="' + attributes['data-item-id'] + '"]');
			if( parseFloat( model.remaining_plain ) > 0.00 ) {
				button.html( model.remaining);
			} else {
				var replacement = $('<span class="label label-danger"></span>');
				replacement.html( model.remaining );
				button.replaceWith(replacement);
			}
		};

		/**
		 * [addToNotes description]
		 * @param {[type]} model [description]
		 */
		var addToNotes = function( model )
		{
			var tbody = $('[data-for="notes"]');
			var tr = $('<tr />')
				.append($('<td />').html(model.note.display_date) )
				.append($('<td />').html('System') )
				.append($('<td />').html(model.note.content) );
			tr.appendTo(tbody);
		};

		/**
		 * [onEditRemainingClickEvent description]
		 * @param  {[type]} e [description]
		 * @return {[type]}   [description]
		 */
		var onEditRemainingClickEvent = function(e)
		{
			e.preventDefault();
            $.fn.ensphere.veto.modalEdit( this, {
				onComplete : function( model, attributes, modal ) {
					addToPayments( model );
					updateRemaining( model, attributes );
					addToNotes( model );
					modal.semanticUiModal('hide');
				}
			});
		};

		/**
		 * [bindEvents description]
		 * @return {[type]} [description]
		 */
		var bindEvents = function()
		{
			$('[data-for="add-item"]').click( onAddItemClickEvent );
			$('[data-for="attaching-note"]').click( onAddNoteClickEvent );
			$('[data-for="edit-remaining"]').click( onEditRemainingClickEvent );
		};

		/**
		 * [init description]
		 * @return {[type]} [description]
		 */
		this.init = function()
		{
			bindEvents();
		};

	};


	/**
	 * [init description]
	 * @return {[type]} [description]
	 */
	this.init = function(){

		if( $('.edit.category, .create.category').length ) {

			var categoriesApp = new shopApp.categories();
			categoriesApp.init();

		}

		if( $('.edit.product, .create.product').length ) {

			var inventoryApp = new shopApp.inventories();
			inventoryApp.init();

			var productsApp = new shopApp.products();
			productsApp.init();

		}

		if( $('.create-order').length ) {

			var createApp = new shopApp.create();
			createApp.init();

		}

		if( $('.view-order').length ) {

			var viewOrder = new shopApp.viewOrder();
			viewOrder.init();

		}

		var selectors = [
			'.products.list .trash.icon',
			'.teachers.list .trash.icon',
			'.option-groups.list .trash.icon',
			'.group-options.list .trash.icon',
			'.venues.list .trash.icon',
			'.align.trash.red.icon',
			'.reply.red.icon'
		];

		if( $(selectors.join(', ') ).length ) {

			$(selectors.join(', ') ).parent().not('.no-confirm').click( function(e){
				var button = $(this);
				e.preventDefault();
				swal({
			        title: "Are you sure?",
			        text: "This action cannot be reversed",
			        type: "warning",
			        showCancelButton: true,
			        confirmButtonClass: 'btn-danger',
			        confirmButtonText: 'Yes, delete it!',
			        cancelButtonText: "No, cancel please!",
			        closeOnConfirm: false,
			        closeOnCancel: false
		        }, function( isConfirm ) {
			        if ( isConfirm ) {
			            window.location = button.attr('href');
			        } else {
			            swal.close();
			        }
			    });
			});

		}

		$.fn.ensphere.veto.wysiwyg( '.redactor' );

	};

};

jQuery(document).ready( function($){

	var activateSelectors = [
		'.venues.list',
		'.group-options.list',
		'.option-groups.list',
		'.teachers.list',
		'.categories.list',
		'.products.list',
		'.edit.product',
		'.create.product',
		'.edit.category',
		'.create.category',
		'.create.venue',
		'.edit.teacher',
		'.create.teacher',
		'.create-order',
		'.view-order',
		'.edit.brand',
		'.create.brand'
	];

	if( $(activateSelectors.join(', ')).length )
	{
		try{
			var shopApplication = new shop();
			shopApplication.init();
		}
		catch( err ) {
			console.log(err);
		}
	}

    $(".orders-check-all").click(function(){
			if ($(this).is(":checked")) {
                $('input:checkbox').not(this).prop('checked', true);
			} else {
                $('input:checkbox').not(this).prop('checked', false);
			}

    });

	$('.toggle-inventory-status').change(function(){
		if($(this).is(':checked')){
			$('.inventory-dormant').show();
		} else {
			$('.inventory-dormant').hide();
		}
	});

    if( $('.reports').length ) {

        $('.datepicker').pickadate({
            formatSubmit: 'dd-mm-yyyy'
        });

    }

    if( $('.order-list').length ) {
		$('.order-preview-btn').click(function(){
			var modalId = $(this).data('target')
            $.get( $(this).data('url'), function(response) {
            	console.log($(modalId +' .modal-body'));
                $(modalId + ' .modal-body').html(response);
            });

		});
    }

});

var productAttributes = function()
{

	var selector = '[javascript="product-attributes"]';

	var init = function()
	{
        $.fn.ensphere.veto.wysiwyg( '.wysiwyg', $(selector) );
	};

	return {
		instantiable : function()
		{
			return $( selector ).length;
		},
		init : init()
	};

};

$(function() {
    var api = new customFields();
    if( api.instantiable() ) {
        api.bindEvents();
    }
    var api2 = new abandonedCarts();
    if( api2.instantiable() ) {
        api2.bindEvents();
    }
    var api3 = new productAttributes();
    if( api3.instantiable() ) {
        api3.init();
    }

    $('.clone-product').on( 'click', function(e) {
        var button = $(this);
        e.preventDefault();
        swal({
            title: "Are you sure you want to clone this item?",
            text: "",
            type: "warning",
            showCancelButton: true,
            confirmButtonClass: 'btn-danger',
            confirmButtonText: 'Yes, clone it!',
            cancelButtonText: "No, cancel please!",
            closeOnConfirm: false,
            closeOnCancel: false
        }, function( isConfirm ) {
            if ( isConfirm ) {
                window.location = button.attr('href');
            } else {
                swal.close();
            }
        });
	});

    $('[data-for="checking-all"]').click( function(e) {
    	e.preventDefault();
		if( $('.p-check:checked').length ) {
            $('.p-check').prop( 'checked', false );
		} else {
            $('.p-check').prop( 'checked', true );
		}
    });

});
